export enum PropertyCondition {
    Bad = 'Bad',
    Average = 'Average',
    Nice = 'Nice',
    Great = 'Great',
    Perfect = 'Perfect',
}
